import { authProvider } from "../context/authProvider";
import { useLocation } from "react-router-dom";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import BitacoraFaltantesTable from "../components/Tables/Reportes/BitacoraFaltantesTable";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import "../theme/ReporteCierreDia.css";

/** Reporte faltantes */
const BitacoraFaltantes = () => {
  const { state } = useLocation();

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption={state.dataRouter[0].FCSEGUNDASECCION} />
                </div>
              </div>
              <BitacoraFaltantesTable />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};

export default BitacoraFaltantes;
